import {boolean} from './booleanAnnotation'

/**
 * Annotation builder for a read-only property of a component with type 'boolean'.
 */
export const readOnly = boolean.setup({readOnly: true})
